<template>
  <CreateTenderFooter
    ref="footer"
    :back_btn="!dialog"
    :check-chages="checkChages"
    new-flou
    :next="beforeNext"
    :next_btn="!!card">
    <template
      v-if="dialog"
      #back>
      <sButton
        type="text"
        @click="$emit('update:dialog', false)">
        <sIcon
          class="s-btn-icon"
          rotate="90"
          size="10"
          type="long-arrow"/>
        {{ $t('Common.Back') }}
      </sButton>
    </template>
    <template #next="{ nextFunc, disableNext, disableTooltip }">
      <WithoutCriteriaConfirmationDialog
        v-if="!card"
        :disable-tooltip="disableTooltip"
        :disabled="disableNext"
        :next-func="nextFunc"/>
    </template>
  </CreateTenderFooter>
</template>
<script>
import CreateTenderFooter from 'components/tenders/CreateTenderFooter.vue'
import WithoutCriteriaConfirmationDialog from 'components/tenders/critetia/WithoutCriteriaConfirmationDialog.vue'

import { mapGetters } from 'vuex'
import { criteriasMixin } from 'mixins'

export default {
  name: 'chooseCriteriaCardFooter',
  mixins: [ criteriasMixin],
  props: {
    card: [Object, Number],
    dialog: Boolean,
    bidding_type: Object,
    tender: Object,
  },
  computed: {
    ...mapGetters({
      tenderGeter: 'getNewTender',
      info: 'getNewTenderInfo'
    }),
    biddingType() {
      return this.tender.biddingType
    }
  },
  methods: {
    async beforeNext() {
      const tender = { ...this.tender}

      if ((!this.biddingType?.reducedPriceAvailable || !this.biddingType?.analogAvailable) && this.card) {
        let card = await this.$store.dispatch('infoAboutCriterionCard', this.card) || {}
        let er_formula = !this.biddingType?.reducedPriceAvailable && (card?.useReducedPrice || card.useStandardReducedPrice)
        let er_analog = !this.biddingType?.analogAvailable && card?.criterias?.some(el => el.criterionKind && el.criterionKind !== 'DEFAULT')
        if (er_formula || er_analog) {
          const resultCard = await this.createorUpdateCriteriaCard({
            tender,
            card,
          })
          this.$emit('update:card', resultCard)
          this.$emit('update:dialog', false)
          this.$emit('finish')
        } else {
          this.$emit('update:dialog', false)
          this.$emit('finish')
        }
      }


      tender.criteryCard = this.card || null
      tender.criteryCard = this.card || null
      this.$emit('update:tender', tender)

      this.$emit('update:dialog', false)
      this.$emit('finish')
    },
    checkChages() {
      return this.card !== 0 && this.card != this.info.default?.criteryCard
    },
  },
  components: {
    CreateTenderFooter,
    WithoutCriteriaConfirmationDialog
  }
}
</script>
